<template>
  <v-card elevation="0" class="all-trade-tab rounded-0">
    <v-tabs
      v-model="model"
      :background-color="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'"
    >
      <v-tab :href="`#tab-1`" class="px-0 ml-0" v-if="$canRoute('managers') > 0">MAM</v-tab>
      <v-tab :href="`#tab-2`" v-if="$canRoute('managers') > 0"> PAMM </v-tab>
      <v-tab :href="`#tab-3`" v-if="$canRoute('managers') > 0"> Copy Trade </v-tab>
      <v-tabs-items v-model="model">
        <v-tab-item :value="`tab-1`">
          <v-card flat>
            <MamTab></MamTab>
          </v-card>
        </v-tab-item>
        <v-tab-item :value="`tab-2`">
          <v-card flat>
            <PammTab></PammTab>
          </v-card>
        </v-tab-item>
        <v-tab-item :value="`tab-3`">
          <v-card flat>
            <CopyTrade></CopyTrade>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-card>
</template>
<script>
import MamTab from "@/components/Mam/MamTab.vue";
import PammTab from "@/components/Mam/PammTab.vue";
import CopyTrade from "@/components/Mam/CopyTrade.vue";
export default {

  data() {
    return {
      tab: null,
      model: "tab-1",
    };
  },
  components: {
    MamTab,
    PammTab,
    CopyTrade,
  },
};
</script>
